// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as StyleUtil from "../../domain/common/StyleUtil.bs.js";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as BackButtonComponent from "../BackButtonComponent.bs.js";
import * as ReasonUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReasonUtils.bs.js";

var customerExperienceLogo = RnrAssetManager.getImage("customer_experience_icon.svg");

function getTotalCustomerServicePoints(viewModel) {
  var rewardCategoryAggVM = List.find((function (rewardCategoryAggVM) {
          var match = rewardCategoryAggVM.name;
          return match === 0;
        }), viewModel.cycleAgg.categoryAggList);
  return String(rewardCategoryAggVM.points);
}

function RnrCustomerServiceRewardComponent(Props) {
  var viewModel = Props.viewModel;
  var content = Props.content;
  return React.createElement("div", {
              className: "category-description"
            }, React.createElement("div", {
                  className: "category-description__header"
                }, React.createElement(BackButtonComponent.make, {
                      className: "category-description__backArrow",
                      text: "x"
                    }), React.createElement("div", {
                      className: "category-description__header-name"
                    }, content.category.customerService)), React.createElement("div", {
                  className: StyleUtil.getColor(/* CustomerService */0, "category-description") + " category-description__banner"
                }, React.createElement("img", {
                      className: "category-description__banner-img",
                      src: customerExperienceLogo
                    }), React.createElement("div", {
                      className: "category-description__banner-name"
                    }, content.category.customerService), React.createElement("div", {
                      className: "category-description__banner-text"
                    }, Curry._1(content.getCustomerServiceRewardsDetailsText, getTotalCustomerServicePoints(viewModel)))), React.createElement("div", {
                  className: "category-description__body"
                }, React.createElement("div", {
                      className: "category-description__body-details"
                    }, React.createElement("div", {
                          className: "category-description__body-details-row"
                        }, content.customerServiceDetails.details1, ReasonUtils$Catalyst.nbsp), React.createElement("br", undefined), React.createElement("div", {
                          className: "category-description__body-details-row u-text-bold"
                        }, content.customerServiceDetails.details2, ReasonUtils$Catalyst.nbsp)), React.createElement("div", {
                      className: "category-description__body-guidelines"
                    }, content.customerServiceDetails.sectionHeader), React.createElement("ul", {
                      className: "category-description__body-guidelines-list"
                    }, React.createElement("li", {
                          className: "category-description__body-guidelines-row"
                        }, content.customerServiceDetails.tip1), React.createElement("li", {
                          className: "category-description__body-guidelines-row"
                        }, content.customerServiceDetails.tip2), React.createElement("li", {
                          className: "category-description__body-guidelines-row"
                        }, content.customerServiceDetails.tip3), React.createElement("li", {
                          className: "category-description__body-guidelines-row"
                        }, Curry._1(content.getCustomerServicePer5StarOrderPoints, String(viewModel.computerDetails.orderRatingComputerDetails.points))))));
}

var make = RnrCustomerServiceRewardComponent;

export {
  customerExperienceLogo ,
  getTotalCustomerServicePoints ,
  make ,
  
}
/* customerExperienceLogo Not a pure module */
